import { createContext, useContext, useState } from "react";
import countries from "./countries.json";
export const Authdata = createContext();
export const Authprovider = ({ children }) => {
    const [loading, setLoading] = useState(false)
    const [open, setOpen] = useState(false);
    const [button_loading, setButtonLoading] = useState(false)
    const [citiesList, setCitieslist] = useState([])
    const handleClick = () => {
        setOpen(true);
    };
    const [error, setError] = useState({
        message: "",
        color: ""
    });
    // let base_url = 'http://localhost:5000/';
    // const image_url = 'http://localhost:5000'
    const image_url = 'https://edfura.onrender.com'
    let base_url = 'https://edfura.onrender.com/';
    const globalHeaders = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    };
    const globalFetch = (url, options = {}) => {
        // Ensure options.headers exists and merge with globalHeaders
        options.headers = {
            ...globalHeaders,
            ...options.headers, // In case you need to add additional headers per request
        };
        // Call the native fetch function with the updated options
        return fetch(url, options);
    };
    const getJobs = (data) => {
        setLoading(true);
        return globalFetch(`${base_url}job-get`, {
            method: "POST",
            body: JSON.stringify(data)
        })
            .then(async (response) => {
                setLoading(false);
                const result = await response.json();
                if (response.ok) {
                    return { success: true, data: result };
                } else {
                    return { success: false, error: result };

                }
            })
            .catch((error) => {
                setLoading(false);
                console.error('Login error:', error);
                return { success: false, error: 'An unexpected error occurred. Please try again.' };
            });
    }
    const getCities = () => {
        try {
            const result = countries.map((country) => ({
                name: { common: country.name }
            }));
            return Promise.resolve({ success: true, data: result });
        } catch (error) {
            console.error('Cities error:', error);
            return Promise.resolve({ success: false, error: 'An unexpected error occurred. Please try again.' });
        }
    }
    const createExpertQuestion = async ({ name, email, phoneNumber, question, ask_to }) => {
        setButtonLoading(true);
        setError({ message: "", color: "" });
        try {
            const response = await globalFetch(`${base_url}expert-question`, {
                method: "POST",
                body: JSON.stringify({ name, email, phoneNumber, question, ask_to })
            });
            const result = await response.json();
            if (response.ok) {
                setButtonLoading(false);
                handleClick();
                setError({ message: "Question submitted successfully", color: "success" });
                return { success: true, data: result };
            } else {
                setButtonLoading(false);
                setError({ message: "Failed to submit question.", color: "error" });
                handleClick();
                return { success: false, error: result.error };
            }
        } catch (error) {
            setButtonLoading(false);
            handleClick();
            setError({ message: "Failed to submit question.", color: "error" });
            return { success: false, error: "Internal server error." };
        }
    };
    // Story creation function
    const createStory = async ({ name, email, title, userPicture, storyPicture, category, storyContent }) => {
        setButtonLoading(true);
        setError({ message: '', color: '' });
        try {
            const formData = new FormData();
            formData.append('name', name);
            formData.append('email', email);
            formData.append('title', title);
            formData.append('userPicture', userPicture); // File
            formData.append('storyPicture', storyPicture); // File
            formData.append('category', category);
            formData.append('storyContent', storyContent);
            const response = await fetch(base_url + 'story-create', {
                method: 'POST',
                body: formData,
            });
            const result = await response.json();
            if (response.ok) {
                setButtonLoading(false);
                handleClick();
                setError({ message: 'Story submitted successfully', color: 'success' });
                return { success: true, data: result };
            } else {
                setButtonLoading(false);
                handleClick();
                setError({ message: 'Failed to submit story.', color: 'error' });
                return { success: false, error: result.error };
            }
        } catch (error) {
            setButtonLoading(false);
            handleClick();
            setError({ message: 'Internal server error.', color: 'error' });
            return { success: false, error: 'Internal server error.' };
        }
    };
    const [webData, setWebData] = useState({
        webSettings: null,
        socialMedia: null
    })
    const getHomePage = () => {
        setLoading(true);
        return globalFetch(`${base_url}home-page`)
            .then(async (response) => {
                setLoading(false);
                const result = await response.json();
                if (response.ok) {

                    return { success: true, data: result };
                } else {

                    return { success: false, error: result };

                }
            })
            .catch((error) => {
                setLoading(false);
                console.error('Login error:', error);
                return { success: false, error: 'An unexpected error occurred. Please try again.' };
            });
    }
    const getAllNews = () => {
        setLoading(true);
        return globalFetch(`${base_url}get-all-news`)
            .then(async (response) => {
                setLoading(false);
                const result = await response.json();
                if (response.ok) {

                    return { success: true, data: result };
                } else {

                    return { success: false, error: result };

                }
            })
            .catch((error) => {
                setLoading(false);
                console.error('Login error:', error);
                return { success: false, error: 'An unexpected error occurred. Please try again.' };
            });
    }
    const cvAnalyze = (cv) => {
        setLoading(true);
        return globalFetch(`${base_url}analyze-resume`, {
            method: "POST",
            body: JSON.stringify({ cv })
        })
            .then(async (response) => {
                setLoading(false);
                const result = await response.json();
                if (response.ok) {
                    return { success: true, data: result };
                } else {
                    return { success: false, error: result };
                }
            })
            .catch((error) => {
                setLoading(false);
                console.error('Login error:', error);
                return { success: false, error: 'An unexpected error occurred. Please try again.' };
            });
    }
    const contactUs = async (data) => {
        setButtonLoading(true);
        setError({ message: "", color: "" });
        return globalFetch(`${base_url}contact-create`, {
            method: "POST",
            body: JSON.stringify(data)
        })
            .then(async (response) => {
                setButtonLoading(false);
                const result = await response.json();
                handleClick();
                setError({ message: 'Contact form submitted successfully', color: 'success' });
                return { success: true, data: result };
            })
            .catch((error) => {
                setButtonLoading(false);
                handleClick();
                setError({ message: "Internal server error.", color: "error" });
                return { success: false, error: "Internal server error." };
            })
    }
    const getScholarships = (data) => {
        setLoading(true);
        return globalFetch(`${base_url}scholarship-ge-public`, {
            method: "POST",
            body: JSON.stringify(data)
        })
            .then(async (response) => {
                setLoading(false);
                const result = await response.json();
                return { success: true, data: result };
            })
            .catch((error) => {
                setLoading(false);
                console.error('Login error:', error);
                return { success: false, error: 'An unexpected error occurred. Please try again.' };
            });
    }
    const getNewsDetails = (id) => {
        setLoading(true);
        return globalFetch(`${base_url}get-news-details/${id}`)
            .then(async (response) => {
                setLoading(false);
                const result = await response.json();
                return { success: true, data: result };
            })
            .catch((error) => {
                setLoading(false);
                console.error('Login error:', error);
                return { success: false, error: 'An unexpected error occurred. Please try again.' };
            });
    }
    const getJobDetails = (id) => {
        setLoading(true);
        return globalFetch(`${base_url}job-get-by-id/${id}`)
            .then(async (response) => {
                setLoading(false);
                const result = await response.json();
                return { success: true, data: result };
            })
            .catch((error) => {
                setLoading(false);
                console.error('Login error:', error);
                return { success: false, error: 'An unexpected error occurred. Please try again.' };
            });
    }
    const getScholarshipDetails = (id) => {
        setLoading(true);
        return globalFetch(`${base_url}scholarship-get-by-id/${id}`)
            .then(async (response) => {
                setLoading(false);
                const result = await response.json();
                return { success: true, data: result };
            })
            .catch((error) => {
                setLoading(false);
                console.error('Login error:', error);
                return { success: false, error: 'An unexpected error occurred. Please try again.' };
            });
    }
    const objectToQueryString = (obj, prefix) => {
        const str = [];
        for (let key in obj) {
            if (obj.hasOwnProperty(key)) {
                const k = prefix ? `${prefix}[${key}]` : key;
                const v = obj[key];
                if (typeof v === "object" && !Array.isArray(v)) {
                    str.push(objectToQueryString(v, k));
                } else if (Array.isArray(v)) {
                    v.forEach((val) => {
                        str.push(`${encodeURIComponent(k)}[]=${encodeURIComponent(val)}`);
                    });
                } else {
                    str.push(`${encodeURIComponent(k)}=${encodeURIComponent(v)}`);
                }
            }
        }
        return str.join("&");
    };
    const parseQueryParams = (search) => {
        const params = new URLSearchParams(search);
        const result = {};

        for (let [key, value] of params.entries()) {
            // Arrays handle
            if (key.endsWith("[]")) {
                const cleanKey = key.replace("[]", "");
                if (!result[cleanKey]) result[cleanKey] = [];
                result[cleanKey].push(value);
            }
            // Nested objects like price[min], price[max]
            else if (key.includes("[")) {
                const match = key.match(/(\w+)\[(\w+)\]/);
                if (match) {
                    const mainKey = match[1]; // e.g. price
                    const subKey = match[2];  // e.g. min
                    if (!result[mainKey]) result[mainKey] = {};
                    result[mainKey][subKey] = value;
                }
            }
            // Normal key=value
            else {
                result[key] = value;
            }
        }

        return result;
    };
    const getMediaRoom = (data) => {
        setLoading(true);
        return globalFetch(`${base_url}get-public-stories`, {
            method: "POST",
            body: JSON.stringify(data)
        })
            .then(async (response) => {
                setLoading(false);
                const result = await response.json();
                return { success: true, data: result };
            })
            .catch((error) => {
                setLoading(false);
                console.error('Login error:', error);
                return { success: false, error: 'An unexpected error occurred. Please try again.' };
            });
    }
    const getMediaDetails = (id) => {
        setLoading(true);
        return globalFetch(`${base_url}get-story-by-id/${id}`)
            .then(async (response) => {
                setLoading(false);
                const result = await response.json();
                return { success: true, data: result };
            })
            .catch((error) => {
                setLoading(false);
                console.error('Login error:', error);
                return { success: false, error: 'An unexpected error occurred. Please try again.' };
            });
    }
    const [categoriesList, setCategorieslist] = useState([])
    const getCategories = () => {
        setLoading(true);
        return globalFetch(`${base_url}categories`)
            .then(async (response) => {
                setLoading(false);
                const result = await response.json();
                return { success: true, data: result };
            })
            .catch((error) => {
                setLoading(false);
                console.error('Login error:', error);
                return { success: false, error: 'An unexpected error occurred. Please try again.' };
            });
    }
    const formatPakistaniPhoneNumber = (phoneNumber) => {
        if (phoneNumber && phoneNumber !== "") {
            let phone = phoneNumber.replace(/\D/g, ""); // Remove non-digit characters
            // Handle different input formats
            if (phone.startsWith("92")) {
                phone = phone.slice(2);
            } else if (phone.startsWith("+92")) {
                phone = phone.slice(3);
            } else if (phone.startsWith("0")) {
                phone = phone.slice(1);
            }
            // Ensure the phone number is no longer than 10 digits
            if (phone.length > 10) {
                phone = phone.slice(0, 10);
            }
            return phone; // Return processed phone number
        }
        else {
            return ""
        }
    };
    const [quickNews, setQuickNews] = useState([])
    const getQuickNews = () => {
        setLoading(true);
        return globalFetch(`${base_url}quick-news`)
            .then(async (response) => {
                setLoading(false);
                const result = await response.json();
                return { success: true, data: result };
            })
            .catch((error) => {
                setLoading(false);
                console.error('Login error:', error);
                return { success: false, error: 'An unexpected error occurred. Please try again.' };
            });
    }
    return (
        <Authdata.Provider value={{
            loading,
            error,
            open,
            setOpen,
            setError,
            button_loading,
            getJobs,
            getCities,
            citiesList,
            setCitieslist,
            createExpertQuestion,
            createStory, // expose the function
            getHomePage,
            image_url,
            base_url,
            getAllNews,
            cvAnalyze,
            contactUs,
            getScholarships,
            getNewsDetails,
            getJobDetails,
            getScholarshipDetails,
            objectToQueryString,
            parseQueryParams,
            getMediaRoom,
            getMediaDetails,
            getCategories,
            categoriesList,
            setCategorieslist,
            formatPakistaniPhoneNumber,
            getQuickNews,
            quickNews,
            setQuickNews,
            webData, setWebData
        }}>
            {children}
        </Authdata.Provider>
    )
}
export const useAuth = () => useContext(Authdata);